<template>
  <div class="app-container">
    <div class="flex_center_around bg-fff van-dropdown-menu__bar top_handle">
      <span class="schoolName">{{userInfo.schoolName}}</span>
      <van-dropdown-menu active-color="#ee0a24">
        <van-dropdown-item :title="currentDay"
                           @open="openDate"
                           ref="datePicker">
          <van-datetime-picker v-model="date"
                               type="year-month"
                               :max-date="maxDate"
                               @confirm="selectDate"
                               @cancel="cancelDate"
                               title="请选择年月" />
        </van-dropdown-item>
      </van-dropdown-menu>
      <span class="btn color"
            @click="normalTemp">查看常规考勤</span>
    </div>
    <div class="content">
      <div class="title flex_center_between">
        <span class="fontBold color">
          异常考勤数据
        </span>
        <span>共计：{{exceptionList.length}}条</span>
      </div>
      <div class="table fontSize14 text_c marginTop5">
        <van-row class="fontBold marginBottom5">
          <van-col span="2">序号</van-col>
          <van-col span="6">部门</van-col>
          <van-col span="4">姓名</van-col>
          <van-col span="3">体温</van-col>
          <van-col span="9">时间</van-col>
        </van-row>
        <div v-if="exceptionList.length === 0"
             class="resultTable">
          暂无数据
        </div>
        <div v-if="exceptionList.length > 0"
             class="resultTable">
          <van-row v-for="(item,index) in exceptionList"
                   :class="{'marginBottom5': index !== exceptionList.length - 1 }">
            <van-col span="2">{{index + 1}}</van-col>
            <van-col span="6">{{item.branchName}}</van-col>
            <van-col span="4">{{item.studentName}}</van-col>
            <van-col span="3"
                     class="fontColorRed">{{item.animalHeat ? item.animalHeat : '--'}}</van-col>
            <van-col span="9">
              <div>
                {{item.attendanceDate ? item.attendanceDate : '--'}}</div>

            </van-col>
            <div class="color text_r location">
              <van-icon name="location-o" />
              {{item.deviceName}}
            </div>
          </van-row>
        </div>
      </div>
    </div>
    <loading :loading="isLoading"></loading>
  </div>
</template>

<script>
import { getExceptionList, getBoarderExceptionList } from '@/api'
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import loading from '@/components/loading'
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: { loading },
  data() {
    return {
      abnormalData: {},
      maxDate: new Date(),
      date: new Date(),
      currentDay: '',
      isLoading: false,
      exceptionList: []
    }
  },
  created() {
    // 默认当天日期
    this.currentDay = parseTime(this.date, '{y}-{m}')
    this.getExceptionList()
  },
  methods: {
    getExceptionList() {
      this.isLoading = true
      if (this.$route.query.type === 'dorm') {
        getBoarderExceptionList({
          date: this.currentDay + '-01',
          userId: this.userInfo.id
        })
          .then(res => {
            if (res.code === 200) {
              this.isLoading = false
              this.exceptionList = res.data.list
            } else {
              this.isLoading = false
            }
          })
          .catch(err => {
            this.isLoading = false
          })
      } else {
        getExceptionList({
          date: this.currentDay + '-01',
          userId: this.userInfo.id
        })
          .then(res => {
            if (res.code === 200) {
              this.isLoading = false
              this.exceptionList = res.data.list
            } else {
              this.isLoading = false
            }
          })
          .catch(err => {
            this.isLoading = false
          })
      }
    },
    selectDate(value) {
      this.currentDay = parseTime(value, '{y}-{m}')
      this.$refs.datePicker.toggle()
      this.getExceptionList()
    },
    cancelDate() {
      this.$refs.datePicker.toggle()
    },
    openDate() {
      this.date = new Date(this.currentDay)
    },
    normalTemp() {
      window.history.back()
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  background-color: #eff5fd;
  .color {
    color: rgb(5, 182, 252);
  }
  .top_handle {
    span {
      font-size: 14px;
    }
    // .schoolName {
    //   flex: 1 !important;
    // }
    .btn {
      padding-right: 10px;
    }
    ::v-deep .van-dropdown-menu {
      width: 33.33%;
    }
    ::v-deep .van-dropdown-menu__bar {
      box-shadow: unset;
    }
  }
  ::v-deep .van-popup--top {
    bottom: 0;
    top: unset;
  }
  ::v-deep .van-picker__confirm {
    color: #ee0a24;
  }
  .content {
    padding: 10px;
    height: calc(100% - 50px);
    .title {
      height: 30px;
      line-height: 30px;
    }
    .data,
    .table {
      line-height: 20px;
      background: #cce3ff;
      padding: 10px;
      border-radius: 5px;
    }
    .table {
      padding: 10px 5px;
      max-height: calc(100% - 30px);
      display: flex;
      flex-flow: column;
    }
    .resultTable {
      padding: 15px 0;
      border-radius: 5px;
      flex: 1;
      background-color: #fff;
      overflow-y: auto;
    }
    .location {
      padding-right: 5px;
      margin-top: 3px;
    }
  }
}
</style>